const profileData = {
       firstName: "Lansing",
       lastName: 'Zhang',
       handle: 'lansing.zhang',
       profilePicture: "../../../images/cat.jpg",
       bannerPicture: "../../../images/banner.jpg",
       bio: 'Student, Software Engineer, Business Analytics, Data enthusiast. Retweets and likes are not endorsements.',
       website: 'youtube.com/webdevtv',
       location: 'Boston, MA',
       dateOfBirth: 'November 5,1989',
       dateJoined: 'April 2019',
       tweets: 5196,
       followingCount: 312,
       followersCount: 180
};

const profile = (state = profileData, action) => {
       switch (action.type) {
              case 'update-profile':
              default:
                     return state;
       }
}

export default profile;




